import type { ReactNode } from 'react';
import { Overflow, OverflowItem, useOverflowMenu } from '@fluentui/react-components';
import classNames from 'classnames';

type TProps = {
  items: { value: string; content: ReactNode }[];
};

const HiddenCount = () => {
  const { ref, overflowCount, isOverflowing } = useOverflowMenu<HTMLSpanElement>();
  if (!isOverflowing) return null;
  return (
    <span ref={ref} className="self-center whitespace-nowrap text-neutral-500">
      +{overflowCount}
    </span>
  );
};

// Filter-bar multiselects keep a fixed width and summarise the selection: as many selections as fit, then a "+N"
// count for the rest. Tag pickers that grow with their content belong in dialogs, not in filter rows.
export const MultiselectSummaryItems = ({ items }: TProps) => (
  <>
    {items.map(({ value, content }, index) => (
      <OverflowItem key={value} id={value}>
        {/* Fluent measures the selections at full width, so only the first, which always shows, may shrink. */}
        <span className={classNames('flex items-center pr-2', index === 0 ? 'min-w-0' : 'shrink-0')}>{content}</span>
      </OverflowItem>
    ))}
    <HiddenCount />
  </>
);

const MultiselectSummary = ({ items }: TProps) => (
  <Overflow minimumVisible={1}>
    <span className="flex min-w-0 flex-1 items-center overflow-hidden whitespace-nowrap">
      <MultiselectSummaryItems items={items} />
    </span>
  </Overflow>
);

export default MultiselectSummary;
